import { Box } from '@mui/material'
import { DataGrid, GridColDef, GridRowsProp } from '@mui/x-data-grid'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../../../redux/types'
import CustomChip from '../../../../../../shared/components/CustomChip'

interface IVipLogsList {
  id: number
  created_by: string
  name: string
  actionId: number
  date: string
}

export function VipLogsTable() {
  const { t } = useTranslation(['global'])

  const { logs } = useSelector((state: IRootState) => state.log)

  const rows: GridRowsProp<IVipLogsList> = logs.filter((log: IVipLogsList) => [1, 2, 7].includes(log.actionId)) ?? []
  const columns: GridColDef[] = [
    { headerName: 'Encargado', field: 'created_by', flex: 1 },
    {
      headerName: t('action'),
      field: 'name',
      flex: 1,
      renderCell: (params: any) => (
        <Box display="flex" alignItems="center" gap={8} height={24} p={1}>
          {params.row.actionId === 1 && <CustomChip type={2} color="primary" label={params.value} />}
          {params.row.actionId === 2 && <CustomChip type={2} color="secondary" label={params.value} />}
          {params.row.actionId === 7 && <CustomChip type={2} color="default" label={params.value} />}
        </Box>
      )
    },
    { headerName: t('date'), field: 'date', flex: 1 }
  ]

  return <DataGrid rows={rows} columns={columns} disableColumnMenu />
}
